import React from "react";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

export default function Switcher() {
    const {t} = useTranslation();
    
    return (
        <>
            <button 
              className="text-xxl font-bold hover:font-black" 
              type="button"
              onClick={() => i18n.changeLanguage(t("other_language"))} 
              >
                  {t("other_language")}
              </button>
        </>
    )
}
